module.exports = __webpack_public_path__ + "img/CM3SF.2545b426.png";